import { DomainUtils, EventDispatcher } from "@ravalmatic/catafractum-utils";
import { ByteBrew } from "bytebrew-web-sdk";

import { GameConstants } from "./GameConstants";
import { PersistentDataManager } from "./PersistentDataManager";
import { GameVars } from "./GameVars";
import { GameEventType, type GameType } from "./Types";
import { AudioManager } from "./AudioManager";

export class GameManager {

    private static currentScene: Phaser.Scene;

    public static setCurrentScene(scene: Phaser.Scene): void {

        GameManager.currentScene = scene;
        GameVars.currentScene = scene;
        AudioManager.onSceneChanged();
    }

    public static init(): void {

        if (!DomainUtils.areValidDomains(GameConstants.VALID_DOMAINS)) {
            return;
        }

        if (GameConstants.USES_BYTE_BREW) {
            ByteBrew.initializeByteBrew(GameConstants.BYTE_BREW_GAME_ID, GameConstants.BYTE_BREW_SDK_KEY, GameConstants.VERSION);
        }

        GameVars.eventsDispatcher = new EventDispatcher<GameEventType>();
        
        GameVars.eventsDispatcher.addEventListener(GameEventType.PRELOAD_COMPLETED, GameManager.onGameAssetsLoaded, GameManager);
        PersistentDataManager.readGameData();
        GameManager.setGameSize();
        GameManager.currentScene.scene.start("PreloadScene");
    }

    private static isDesktopDevice(): boolean {

        const hasTouchPoints = navigator.maxTouchPoints && navigator.maxTouchPoints > 2;
        const isTouchMac = hasTouchPoints && /MacIntel/.test(navigator.platform);

        return GameManager.currentScene.sys.game.device.os.desktop && !isTouchMac;
    }

    public static setGameSize(): void {

        if (!GameManager.currentScene || GameManager.isDesktopDevice()) {
            GameVars.scaleY = 1;
            return;
        }

        const scaleManager = GameManager.currentScene.game.scale;
        const viewportIsLandscape = window.innerWidth >= window.innerHeight;

        GameManager.currentScene.scene.setVisible(false);

        if (GameVars.isLandscape) {

            if (viewportIsLandscape) {
                scaleManager.displaySize = scaleManager.parentSize;
            } else {
                scaleManager.displaySize.width = window.innerWidth;
                scaleManager.displaySize.height = window.innerWidth * (GameConstants.GAME_HEIGHT_LANDSCAPE / GameConstants.GAME_WIDTH_LANDSCAPE);
            }

            GameVars.scaleY = 1;

        } else if (viewportIsLandscape) {

            scaleManager.displaySize.height = window.innerHeight;
            scaleManager.displaySize.width = window.innerHeight * (GameConstants.GAME_WIDTH_PORTRAIT / GameConstants.GAME_HEIGHT_PORTRAIT);
            GameVars.scaleY = 1;

        } else {

            scaleManager.displaySize = scaleManager.parentSize;

            const aspectRatio = window.innerHeight / window.innerWidth;
            GameVars.scaleY = (GameConstants.GAME_HEIGHT_PORTRAIT / GameConstants.GAME_WIDTH_PORTRAIT) / aspectRatio;
        }

        GameManager.currentScene.scene.setVisible(true);
        scaleManager.refresh();

        const relayout = (GameManager.currentScene as Phaser.Scene & { relayout?: () => void }).relayout;
        relayout?.call(GameManager.currentScene);
    }

    public static onGameAssetsLoaded(): void {

        AudioManager.init();
        // GameManager.enterDevelopmentScene();
        GameManager.enterSplashScene();
        // GameManager.enterBoardScene();
    }

    public static enterDevelopmentScene(): void {

        GameManager.currentScene.scene.start("DevScene");
    }

    public static enterSplashScene(): void {

        GameManager.currentScene.scene.start("SplashScene");
    }

    public static enterBoardScene(gameType?: GameType): void {

        if (gameType !== undefined && GameVars.gameData.gameType !== gameType) {
            PersistentDataManager.updateGameData("gameType", gameType);
        }
        GameManager.currentScene.scene.start("BoardScene", {});
    }
}
